import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Drawer.module.scss';
import UIcon from '@/assets/uicons/UIcon';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const DrawerHeader: React.FC<{ children: React.ReactNode, onClose: () => void }> = ({ children, onClose }) => (
  <div className={styles.drawerHeader}>
    <h2>{children}</h2>
    <button onClick={onClose} className={styles.closeButton}>
      <UIcon name="cross" size={20} />
    </button>
  </div>
);

const DrawerBody: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.drawerBody}>{children}</div>
);

const DrawerFooter: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.drawerFooter}>{children}</div>
);

const Drawer: React.FC<DrawerProps> & {
  Header: typeof DrawerHeader;
  Body: typeof DrawerBody;
  Footer: typeof DrawerFooter;
} = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  const handleContentClick = (e: React.MouseEvent) => e.stopPropagation();

  return ReactDOM.createPortal(
    <>
      <div className={`${styles.backdrop} ${isOpen ? styles.isOpen : ''}`} onClick={onClose} />
      <div className={`${styles.drawerContent} ${isOpen ? styles.isOpen : ''}`} onClick={handleContentClick}>
        {children}
      </div>
    </>,
    document.body
  );
};

Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
Drawer.Footer = DrawerFooter;

export default Drawer; 